// v1 onboarding by conversation + project pending items. Schemas in api-onboarding.ts.
import * as O from './api-onboarding.js';
import { IdParam, items, route, W } from './route-def.js';
import { z } from 'zod';

const Chat = z.object({ chatId: IdParam });

export const onboardingRoutes = {
  listOnboardingChats: route({
    method: 'GET', path: '/platform/onboarding-chats', summary: 'Conversaciones de alta (mías)', tag: 'platform',
    capability: 'platform_mcp', response: items(O.OnboardingChatSchema),
  }),
  createOnboardingChat: route({
    method: 'POST', path: '/platform/onboarding-chats', summary: 'Nueva conversación para dar de alta o instruir un proyecto', tag: 'platform',
    capability: 'platform_mcp', body: O.CreateOnboardingChatSchema, response: O.OnboardingChatSchema, status: 201,
  }),
  getOnboardingChat: route({
    method: 'GET', path: '/platform/onboarding-chats/:chatId', summary: 'Conversación de alta', tag: 'platform',
    capability: 'platform_mcp', params: Chat, response: O.OnboardingChatSchema,
  }),
  sendOnboardingMessage: route({
    method: 'POST', path: '/platform/onboarding-chats/:chatId/messages', summary: 'Escribir a LÍA en la conversación de alta', tag: 'platform',
    capability: 'platform_mcp', params: Chat, body: O.SendOnboardingMessageSchema, response: O.OnboardingChatSchema,
  }),
  listProjectPendingItems: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/pending-items', summary: 'Pendientes del proyecto (responsable y condición de cierre)', tag: 'projects',
    minRole: 'advisor', params: W({ projectId: IdParam }), response: items(O.ProjectPendingItemSchema),
  }),
  createProjectPendingItem: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/pending-items', summary: 'Registrar un pendiente', tag: 'projects',
    minRole: 'manager', params: W({ projectId: IdParam }), body: O.CreateProjectPendingItemSchema, response: O.ProjectPendingItemSchema, status: 201,
  }),
  closeProjectPendingItem: route({
    method: 'POST', path: '/workspaces/:workspaceId/pending-items/:itemId/close', summary: 'Cerrar un pendiente (nota de cómo se cumplió la condición)', tag: 'projects',
    minRole: 'manager', params: W({ itemId: IdParam }), body: O.CloseProjectPendingItemSchema, response: O.ProjectPendingItemSchema,
  }),
  projectSetupOverview: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/setup-overview', summary: 'Estándar heredado vs decisiones del proyecto, pendientes, preguntas y discrepancias', tag: 'projects',
    minRole: 'advisor', params: W({ projectId: IdParam }), response: O.ProjectSetupOverviewSchema,
  }),
};
